<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-individual-factor" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Faktornamn" v-model="factorName" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined"  label="Beräkningstyp" :items="calculationTypes" v-model="selectedCalculationType" item-title="name" item-value="val"></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined"  label="Omfattning" :items="extents" v-model="selectedExtent" item-title="name" item-value="val"></v-select>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import WageService from "../../../Services/WageService";
    import { getCurrentInstance } from 'vue'
 
    export default {
        emits: ['updated'],
        name: 'update-individual-factor',
        props: {
            
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                await WageService.updateIndividualFactor(this.individualFactorId, this.factorNumber, this.factorName, this.selectedCalculationType, this.selectedExtent)
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");  
            },
            open(item) {
                this.individualFactorId = item.IndividualFactorId;
                this.factorNumber = item.FactorNumber;
                this.factorName = item.FactorName;
                this.selectedCalculationType = item.CalculationType;
                this.selectedExtent = item.Extent;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.individualFactorId = null;
                this.factorNumber = null;
                this.factorName = null;
                this.selectedCalculationType = null;
                this.selectedExtent = null;
            },
        },
        data() {
            return {
                calculationTypes: [
                    { short: "Ingen", name: "Ingen beräkning", val: 0 },
                    { short: "Anställningsd.", name: "Anställningsdatum", val: 1 },
                    { short: "Anställd i y.", name: "Anställd i yrket", val: 2 },
                ],
                extents: [
                    { name: "Alla", val: 0 },
                    { name: "Individ", val: 1 },
                ],
                individualFactorId:null,
                factorNumber: null,
                factorName: null,
                selectedCalculationType: null,
                selectedExtent:null,
                dialogueVisible: false,
                thisModal: {},
            };
        },
        watch: {

        },
        mounted() {
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
